const initData = {
    baseData: {
        effectiveDate: {}
    }
};

export default initData;
